import { create } from "zustand"
import type { TAnnotationCategory, TAnnotationMetadata, TAnnotationVisibility } from "types/annotations.type"

const DEFAULT_VISIBILITY: TAnnotationVisibility = {
	"eref:connected": true,
	"eref:unconnected": true,
	"ecall:connected": true,
	"ecall:unconnected": true,
	"furniture:connected": true,
	"furniture:unconnected": true,
	// Page-name detection boxes carry no connectivity; only the "connected" key is ever
	// drawn (see AnnotationService.renderAnnotations), but both are required by the record type.
	"page:connected": true,
	"page:unconnected": true,
}

type AnnotationsStore = {
	visibility: TAnnotationVisibility
	selectedAnnotation: TAnnotationMetadata | null

	toggleCategoryVisibility: (category: TAnnotationCategory) => void
	setUnconnectedVisible: (visible: boolean) => void
	setSelectedAnnotation: (metadata: TAnnotationMetadata) => void
	clearSelection: () => void
}

export const useAnnotationsStore = create<AnnotationsStore>((set) => ({
	visibility: DEFAULT_VISIBILITY,
	selectedAnnotation: null,

	toggleCategoryVisibility: (category) =>
		set((state) => ({
			visibility: {
				...state.visibility,
				[category]: !state.visibility[category],
			},
		})),

	setUnconnectedVisible: (visible) =>
		set((state) => ({
			visibility: {
				...state.visibility,
				"eref:unconnected": visible,
				"ecall:unconnected": visible,
			},
		})),

	setSelectedAnnotation: (metadata) => set({ selectedAnnotation: metadata }),

	clearSelection: () => set({ selectedAnnotation: null }),
}))
